import service from '~api/knowledge';
import * as types from '../types';

const loop = (data, level) =>
  data.filter((v) => {
    v.label = v.menuName;
    v.value = v.id;
    v.is_shown = false;
    v.is_level = level;
    if (v.childrenList.length > 0) {
      const arr = loop(v.childrenList, level + 1);
      v.children = arr.sort((a, b) => a.menuOrder < b.menuOrder);
    }
    return level < 3;
  });

export default {
  getKnowData({ commit }, payload) {
    return service.apiGetKnowList(payload).then((res) => {
      if (res.data) {
        commit(types.GET_KNOW_LIST, res.data);
      }
    });
  },
  getTreeData({ commit }, payload) {
    return service.apiGetTreeData(payload).then((res) => {
      if (res.data) {
        if (res.data.data === null) {
          const value = {
            label: '全部文档',
            value: '0',
            parentId: '',
            id: '0',
            menuName: '全部文档',
            menuOrder: 0,
            is_shown: false,
            is_level: 0,
            children: [],
          };
          commit(types.GET_KNOW_TREE, [value]);
        } else {
          loop(res.data.childrenList, 1);
          const result = [
            {
              label: res.data.menuName,
              value: res.data.id,
              id: res.data.id,
              menuOrder: res.data.menuOrder,
              parentId: res.data.parentId,
              is_shown: false,
              is_level: 0,
              children: res.data.childrenList,
            },
          ];
          commit(types.GET_KNOW_TREE, result);
        }
      }
    });
  },
  addMenu({ commit }, payload) {
    return service.apiAddKnowMenu(payload);
  },
  editMenu({ commit }, payload) {
    return service.apiEditKnowMenu(payload);
  },
  deleteMenu({ commit }, payload) {
    return service.apiDeleteKnowMenu(payload);
  },
  moveMenu({ commit }, payload) {
    return service.apiMoveKnowMenu(payload);
  },
  getKnowDetail({ commit }, payload) {
    return service.apiGetKnowDetail(payload).then((res) => {
      if (res.data) {
        commit(types.GET_KNOW_DETAIL, res.data);
      }
    });
  },
  getKnowTeam({ commit }, payload) {
    return service.apiGetQueryTeam(payload).then((res) => {
      if (res.data) {
        const func = data =>
          data.forEach((item) => {
            if (item.children.length === 0) {
              delete item.children;
            } else {
              func(item.children);
            }
          });
        func(res.data.children);
        const arr = [
          {
            ...res.data,
            children: res.data.children,
          },
        ];

        commit(types.GET_KNOW_TEAM, arr);
      }
    });
  },
  uploadCompactFile({ commit }, payload) {
    return service.apiGetUploadFile(payload.params, payload.config);
  },
  addKnowDoc({ commit }, payload) {
    return service.apiAddKnowDoc(payload);
  },
  updateKnowDoc({ commit }, payload) {
    return service.apiUpdateKnowDoc(payload);
  },
  deleteKnowDoc({ commit }, payload) {
    return service.apiDeleteKnowDoc(payload);
  },
  toTop({ commit }, payload) {
    return service.apiKnowTop(payload);
  },
  getFileList({ commit }, payload) {
    return service.apiGetFileList(payload).then((files) => {
      if (res.data) {
        commit(types.GET_KNOW_FILELIST, res.data);
      }
    });
  },
};
